import React from 'react';

import withConditionalLink from '../../hoc/with-conditional-link';
import Counter from '../counter';

export const CommentCount = props => <Counter i18nKey="comment-count.label" {...props} />;

export default withConditionalLink(CommentCount);
